/**
 * @title image-lightbox.js: Sub-module of Product feature
 * @description This module encapsulates all of the
 * functionality related to the image-lightbox view component of product display.
 * @dependency dialog.js, mathtable.js, zoom-viewer.js
 */
define(['mathtable','zoomViewer'], function(CMath,ZoomViewer) {
  var ImageLightboxView = {
    
    /**
     * Opens Image Lightbox modal.
     */
    openImageLightBoxModal: function(event) {
    	
    	if ($('#zoomViewer').length) {
    		
    		let currentWindowPosition = $(window).scrollTop();
    		if(!$('#theViews').is(':empty')) {
      	      $('#theViews').slick('destroy');
    	      $('#theViews').find('a[tabindex]').remove();
    		}
    	      let zoomViewerHTML = $('#zoomViewer')[0].outerHTML;
    	      $('#zoomViewer').remove();
    	      if(event !== undefined){
        	      ImageLightboxView.saveFocusedElement(event);
    	      }
    	      COSTCO.dialog.createExtDialogBox({
    	        body: COSTCO.util.tmpl('tmpl_modal_lightbox',{}),
    	        hideFooter: true,
    	        dialogclasses: 'medium image-lightbox-modal image-lightbox-modal-v2',
    	        onshow: function() {
    	        	
    	        	$(window).on('scroll', {position: currentWindowPosition}, COSTCO.ZoomViewer.lockWindowScrolling);
    	            $(window).on('error', COSTCO.ZoomViewer.reloadThumbnailsOnScriptError);
    	        	$('body').addClass('image-lightbox-modal-open');
    	        	ImageLightboxView.bindNextArrowEvent();
    	        	ImageLightboxView.bindPrevArrowEvent();
    	        	$("#costcoModal").addClass('lightbox-modal-v2');

    	        },
    	        onclose: function() {        	
    	          
    	        	$(window).off('scroll', COSTCO.ZoomViewer.lockWindowScrolling);
    	        	$(window).off('error', COSTCO.ZoomViewer.reloadThumbnailsOnScriptError);
	    	    
    	        	$('.top-content').prepend(zoomViewerHTML);
	    	          
    	        	ZoomViewer.cleanupEvents();
	    	        ZoomViewer.resetLiveclicker();
	    	        
	    	        RICHFX.load.fullReset();
	    	        $('#theViews').removeClass();
	    	        $('#theViews').empty();
	    	        initZoomViewer();
	    	        RICHFX.init();
	    	        setInitialSwatchValues();
	    	        $('body').removeClass('image-lightbox-modal-open');
    	        	$("#costcoModal").removeClass('lightbox-modal-v2');

    	        }
    	      });
    	      
    	      document.addEventListener('richmedia.state.loaded', COSTCO.ZoomViewer.richMediaLoaded);
              document.addEventListener('richmedia.view.changed', COSTCO.ZoomViewer.richMediaViewChange);
              document.addEventListener('richmedia.swatch.changed', COSTCO.ZoomViewer.richMediaSwatchChange);
             
              ZoomViewer.initZoomViewer();
              ZoomViewer.constants.imageLightboxV2 = true;
              RICHFX.load.fullReset();
              RICHFX.init();
              
          	  $('#viewsPrevArrow').addClass('hideViewsArrow');
    	}
    },
    
    /**
     * Executes when click on arrow for the next slide
     */
    bindNextArrowEvent: function() {
    	
    	$('#viewsNextArrow').on('click', function(){
    		
    		let slides = $('#theViews').find('a').length;
    		
    		$('#viewsPrevArrow').removeClass('hideViewsArrow');
    		
    		if (ZoomViewer.constants.currentSlide < slides - 1) {
    			
    			if (ZoomViewer.constants.currentSlide == slides - 2 ) {
    				$('#viewsNextArrow').addClass('hideViewsArrow');
    			}
    			
    			ZoomViewer.constants.currentSlide = ZoomViewer.constants.currentSlide + 1;
        		let currentSlide = $('#theViews').find('a')[ZoomViewer.constants.currentSlide];
        		
        		$(currentSlide).find('img').click();     
        		$('.selectedSlide').first().focus();
    		}
    	});
    },
    
    /**
     * Executes when click on arrow for the previous slide
     */
    bindPrevArrowEvent: function() {
    	
    	$('#viewsPrevArrow').on('click', function(){
    		
    		let slides = $('#theViews').find('a').length;
    		
    		$('#viewsNextArrow').removeClass('hideViewsArrow');
    		
    		if (ZoomViewer.constants.currentSlide > 0) {
    			
    			if (ZoomViewer.constants.currentSlide == 1) {
    				$('#viewsPrevArrow').addClass('hideViewsArrow');
    			}
    			
        		ZoomViewer.constants.currentSlide = ZoomViewer.constants.currentSlide - 1; 	        		
        		let currentSlide = $('#theViews').find('a')[ZoomViewer.constants.currentSlide];
        		
        		$(currentSlide).find('img').click();
        		$('.selectedSlide').first().focus();
    		}		
    	});
    },
    
    /**
     * Saved id of focused element  on lightbox open
     */
  	 saveFocusedElement: function(event) {
  	 	if (typeof event !== 'undefined') {
	  		 if(event.target.id) {
	  		     $('<input>').attr({
	  					type: 'hidden',
	  					id: 'lastFocusedElement',
	  					value: event.target.id
	  				}).appendTo('body');
	  		 } else {
	  			 //keyboard event was triggered
	  			 img = $(event.target).find('img').attr('id');
	  			 elementId = $(event.target).find('img').attr('id');
	  			 if(elementId) {
	  			     $('<input>').attr({
	  						type: 'hidden',
	  						id: 'lastFocusedElement',
	  						value: elementId
	  					}).appendTo('body');
	  			 }
	  		 }
  		 }
  	 },
  }
  
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = new Object();
  }
  
  window.COSTCO.ImageLightboxView = ImageLightboxView;
  
  return ImageLightboxView;
});



// WEBPACK FOOTER //
// ./js/product/image-lightbox.js